<template>
  <van-tabbar v-model="active">
    <van-tabbar-item to="/">
      <img slot="icon" slot-scope="props" :src="props.active ? icon.cinema_active : icon.cinema_normal" >
      <span>购票</span>
    </van-tabbar-item>
	  <van-tabbar-item to="/orders">
      <img slot="icon" slot-scope="props" :src="props.active ? icon.orders_active : icon.orders_normal" >
      <span>订单</span>
    </van-tabbar-item>
    <van-tabbar-item  to="/user">
      <img slot="icon" slot-scope="props" :src="props.active ? icon.mine_active : icon.mine_normal" >
      <span>我的</span>
    </van-tabbar-item>
    <!--
    <van-tabbar-item  to="/auth">
      <img slot="icon" slot-scope="props" :src="props.active ? icon.mine_active : icon.mine_normal" >
      <span>同步</span>
    </van-tabbar-item>
    -->
  </van-tabbar>
</template>

<script>
  export default {
    data() {
      return {
        active: this.$store.state.tabactive,
        icon: {
          cinema_normal: require('../static/menu_icon_cinema.png'),
          cinema_active: require('../static/menu_icon_cinema_selected.png'),
          orders_normal: require('../static/menu_icon_orders.png'),
          orders_active: require('../static/menu_icon_orders_selected.png'),
          mine_normal: require('../static/menu_icon_mine.png'),
          mine_active: require('../static/menu_icon_mine_selected.png'),
        }
      }
    }
  }
</script>

<style>
  .van-tabbar-item--active{
    color: #DD403B;
  }

  .van-tabbar{
    height: 80px;
  }
  .van-tabbar-item{
    line-height: 1.5;
  }
  .van-tabbar-item__icon img{
    width: 35px;
    height: 35px;
  }

  .van-tabbar--fixed{
    /*
      padding-bottom: constant(safe-area-inset-bottom);
    padding-bottom:  env(safe-area-inset-bottom);
    */
  }
</style>